import Vue from 'vue'
import Http from 'axios'

export default {
    /*
    * Updates page title and meta description
    */
    updateMedadata(page) {
        document.title = page.meta.title;
        let metaDesc = document.querySelector('meta[name="description"]');

        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.insertBefore(metaDesc, document.querySelector('meta[name="author"]'));
        }

        metaDesc.setAttribute("content", page.meta.description);

        // Update Open Graph Tags
        document.querySelector('meta[property="og:url"]').setAttribute('content', `${window.location.protocol}//${window.location.host}${page.path}`);
        document.querySelector('meta[property="og:title"]').setAttribute('content', page.meta.title);
        document.querySelector('meta[property="og:description"]').setAttribute('content', page.meta.description);
    },

    /*
    * Function to convert a Nitrous Uri model to a Vue route
    */
    convertUriToRoute(uri, prefetch = true) {
        let meta = {
            id: uri.id,
            title: uri.page_title,
            description: uri.meta_description,
            isHome: uri.isHome || false,
            model: typeof uri.uriable !== 'undefined' ? uri.uriable.parent : null,
            alternateLanguages: uri.alternateLanguages || []
        };

        meta.loadData = () => {
            return Http.get(`/api/${uri.slug}`);
        };

        let route = {
            name: uri.isHome ? 'home' : `page-${uri.id}`,
            path: '/' + (uri.slug == '/' ? '' : uri.slug),
            component: () => System.import('#app#/components/package/' + uri.controllerType + 'Controller.vue' /* webpackChunkName: "[request]" */),
            meta: meta
        };

        return route;
    },

    /*
    * Function for scrolling to an anchor
    */
    scrollToAnchor(anchor) {
        const el = document.querySelector(anchor);
        if (el) {
            setTimeout(() => Vue.helpers.scrollTo(el), Vue.pageTransitionDuration);
        }
    },
}


// WEBPACK FOOTER //
// ../default-js/js/router/functions.js